import React from 'react';
export function Footer() {
  return <footer className="bg-white text-[#777] text-center py-10 px-5 text-[0.9rem] font-sans" data-id="element-45">
      <p className="mb-2" data-id="element-46">🌿 Vínculos de Vida - Residencia de Larga Estadía</p>
      <p data-id="element-47">General Ramírez, Entre Ríos, Argentina.</p>
    </footer>;
}